import fetch from '@/utils/fetch'

export function addNewProblem2pre (data) {
  return fetch({
    url: '/createProblems',
    data,
    method: 'post'
  })
}

export function addNewFhProblem (data) {
  return fetch({
    url: '/fhcreateProblems',
    data,
    method: 'post'
  })
}

export function uploadProblemImg (formdata) {
  return fetch({
    url: '/uploadProblemImg',
    method: 'post',
    headers: {'Content-Type': 'multipart/form-data'},
    timeout: 10000,
    data: formdata
  })
}

export function deleteProblem (pguid) {
  return fetch({
    url: '/deleteProblem',
    method: 'post',
    data: pguid
  })
}

export function getOssId () {
  return fetch({
    url: '/oss',
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/problems.js